import { Env, readFromEnv } from "@cinch-nx/environments";
export var VEHICLE_SEARCH_URL = "".concat(readFromEnv(Env.SearchServiceUrl), "/vehicles");
export var AFFILIATE_VEHICLES_URL = "".concat(readFromEnv(Env.SearchServiceUrl), "/affiliate-vehicles");
